import { useCallback } from 'react';
import ShipDarkerImage from '@shared/assets/images/v2/ship-darker.svg';
import { MBButton } from '@shared/components/MBButton';
import { Text } from '@shared/components/Text';
import { ButtonView, View } from '@shared/components/View';
import { useIsDesktop } from '@shared/util/hooks';
import { i18n } from '@shared/util/i18n';
import { MBLinking } from '@shared/util/linking';
import { MBRestart } from '@shared/util/restart';
import classNames from './UnchartedWaters.module.css';

interface UnchartedWatersProps {
  error: Error;
}

export function UnchartedWaters({ error }: UnchartedWatersProps) {
  const isDesktop = useIsDesktop();

  const handleSupport = useCallback(() => {
    const body = {
      error: String(error),
      stack: error.stack,
    };
    const EMAIL_URL = import.meta.env.VITE_CONTACT_EMAIL_URL;
    MBLinking.open(`${EMAIL_URL}?subject=Uncharted+Waters&body=${JSON.stringify(body)}`);
  }, [error]);

  return (
    <View center className={classNames.container}>
      <View center className={classNames.content}>
        <ShipDarkerImage className={classNames.image} />
        <View paddingBottom={1}>
          <Text size={isDesktop ? 'h4' : 'subtitle'}>{i18n('errors.unhandled.heading')}</Text>
        </View>
        <View paddingBottom={4}>
          <Text size="body2">{i18n('errors.unhandled.subHeading')}</Text>
        </View>
        <View paddingBottom={4}>
          <MBButton
            onPress={() => MBRestart.restart()}
            title={i18n('errors.unhandled.reloadButton')}
            theme="outline"
          />
        </View>
        <View row={isDesktop} center>
          <View marginRight={1} marginTop={1}>
            <Text size="body2">{i18n('errors.unhandled.helpMessage')}</Text>
          </View>
          <View row marginTop={1}>
            <ButtonView onClick={handleSupport}>
              <Text size="body2" weight="semibold">
                {i18n('errors.unhandled.helpLink')}
              </Text>
            </ButtonView>
          </View>
        </View>
      </View>
    </View>
  );
}
